import proj4 from 'proj4';
/**
 * Krok GPS1 — S-JTSK (Krovak East North, EPSG:5514) <-> WGS84 (EPSG:4326).
 *
 * Zde JE definice 5514, jediná v repozitari. `apps/web-admin/src/lib/
 * parcel-map-crs.ts` (krok M1) ji drivej definoval sám; krok GPS1 pridal
 * druheho konzumenta (sdilena knihovna parsovani, ktera prevadi S-JTSK
 * vstupni retezec na bod), a dve definice 5514 by se casem rozešly — vedlo
 * by to k tomu, ze admin ukaze jinou parcelu nez veejny web.
 *
 * `towgs84` je sedmiprvkova Helmertova transformace S-JTSK <-> WGS84, jak ji
 * pouziva CUZK (EPSG:5514). Bez ni by byl prevod o desitky metru vedle.
 *
 * ROZHODNUTI GPS1: prevod je V PROHLIZECI, ne na serveru. Server (`/v1/
 * duediligence/map/parcel-at-point`, `GET /geo/v1/parcels/from-coords`) prijima
 * uz hotovy bod; kdyby prevod zustal na serveru, zadani „souradnice textem"
 * by nebezelo bez site a kazde kliknuti do mapy by delo dve delegace.
 */
export const EPSG_5514 = 'EPSG:5514';
/** Oficialni parametry EPSG:5514 (epsg.io/5514). */
export const EPSG_5514_DEF = '+proj=krovak +lat_0=49.5 +lon_0=24.83333333333333 +alpha=30.28813972222222' +
    ' +k=0.9999 +x_0=0 +y_0=0 +ellps=bessel' +
    ' +towgs84=570.8,85.7,462.8,4.998,1.587,5.261,3.56 +units=m +no_defs';
let defined = false;
/** Idempotentni — volatelna z kazdeho konzumenta, ktery 5514 potrebuje. */
export function defineSjtskProjection() {
    if (defined)
        return;
    proj4.defs(EPSG_5514, EPSG_5514_DEF);
    defined = true;
}
function toFinite(value) {
    if (typeof value === 'number' && Number.isFinite(value))
        return value;
    throw new Error('geo-input: prevod S-JTSK <-> WGS84 selhal (neciselny vysledek)');
}
/** S-JTSK (5514) -> WGS84 (4326) — stejny vypocet jako v kroku M1. */
export function sjtskToWgs84(point) {
    defineSjtskProjection();
    const [lon, lat] = proj4(EPSG_5514, 'EPSG:4326', [point.x, point.y]);
    return { lat: toFinite(lat), lon: toFinite(lon) };
}
export function wgs84ToSjtsk(point) {
    defineSjtskProjection();
    const [x, y] = proj4('EPSG:4326', EPSG_5514, [point.lon, point.lat]);
    return { x: toFinite(x), y: toFinite(y) };
}
//# sourceMappingURL=crs.js.map